import { useMemo } from 'react';
import { useBookingContext } from '../modules/booking-state/UseBookingContext';

export interface Partner {
  informationName: string;
  informationBrand: string,
  informationZIP: string;
  informationBnr: string;
  informationCountry: string;
  SearchNumberOfResults: number;
}

export function usePartner(): Partner | undefined {
  const [bookingState] = useBookingContext();
  const value = useMemo<Partner | undefined>(() => {
    if (bookingState.selectedDealer && bookingState.foundDealersCount) {
      return {
        informationCountry: 'ZA',
        informationBrand: bookingState.selectedDealer.brand,
        informationName: bookingState.selectedDealer.name,
        informationZIP: bookingState.selectedDealer.postalCode,
        informationBnr: bookingState.selectedDealer.dealerCode,
        SearchNumberOfResults: bookingState.foundDealersCount
        }
      }
    else {
      return undefined
    }
  }, [bookingState]);

  return value;
}
